import React, { useContext, useEffect } from "react"

// Components
import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import AdvancedSearch from "./components/AdvancedSearch"

import { UserContext } from "../../context/userContext"

export default function MyParticipants() {
  const userCtx = useContext(UserContext)

  useEffect(() => {
    userCtx.clearParticipant()
  }, [])

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <ParticipantSidebar searchType="my_participants" />
      </div>
      <div className="main-content">
        <h1>My Participants</h1>
        <AdvancedSearch searchType="my_participants" />
      </div>
    </div>
  )
}
